module.exports = __webpack_public_path__ + "static/media/HamburgerMenu.13cd1b50.svg";